<tp-base-layout
    [tabs]="playerActivityDetails?.content?.tabs"
    [clientContent]="playerActivityClientContent"
    [title]="playerActivityDetails?.content?.title">
    @if (currentTab) {
        <ng-container
            [onLoadWebTracker]="{
                LabelEvent: webAnalyticModel.page,
                ActionEvent: 'Player Activity Promotion - Loaded',
                PositionEvent: currentTab,
                EventDetails: webAnalyticModel.promoId,
            }"></ng-container>
    }
</tp-base-layout>
